export default __webpack_public_path__ + "static/media/lighthouse.8f25b882.svg";